export function dedupeByKey<T>(
	arr: T[],
	key: keyof T
) {
	const uniqueMap = new Map<T[keyof T], T>();
	for (const obj of arr) {
		if (!uniqueMap.has(obj[key])) {
			uniqueMap.set(obj[key], obj);
		}
	}

	return Array.from(uniqueMap.values());
}